import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {toast} from 'react-toastify';
import {getPayerAccount, getSelectedPrimaryAccount, getSelectedSecondaryAccount} from "../invoice/Selectors";
import {extractLastCardNumbers} from "../../actions/InvoiceActions";
import {Formik} from "formik";
import {AddCheckSchema, EditCheckSchema} from "./schemas";
import {BootstrapError, BootstrapField} from "../../helpers/Field";
import {ERROR_PAYMENT_METHOD} from "../../constants/ErrorMessages";
import {faChevronDown} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export class AddCheckForm extends Component {
  constructor(props) {
    super(props);
    this.saveCard = this.saveCard.bind(this);
    this.buttonText = this.buttonText.bind(this);
  }

  async saveCard(card) {
    this.props.save(card);
  }
  
  buttonText() {
    if(this.props.alwaysSaveOnFile){
    return this.props.isEditing ?  "Update eCheck" : "Save eCheck";
    } else {
      return "Next";
    }
  }

  render() {
    let initialValues = {
      type: "",
      name: "",
      routing_number: "",
      account_number: "",
      save_on_file: this.props.alwaysSaveOnFile,
      make_default: false,
    };
    let schema = AddCheckSchema;
    if (this.props.isEditing) {
      initialValues = {
        type: "",
        name: this.props.payment.payment_card_name,
        routing_number: "*********",
        account_number:  `ending in *${extractLastCardNumbers(this.props.payment.payment_card_token, '-')}`,
        save_on_file: !this.props.payment.is_session,
        make_default: this.props.isDefault,
      };
      schema = EditCheckSchema;
    }
    return <div>
      <Formik
        initialValues={
          initialValues
        }
        validationSchema={
          schema
        }
        enableReinitialize={true}
        onSubmit={(values, bag) => {
          bag.setSubmitting(true);
          this.saveCard(values).then((paymentcard) => {
            bag.setSubmitting(false);
            if (this.props.onCardConfirmed) {
              this.props.onCardConfirmed(paymentcard);
            }
          }).catch(() => {
            toast.error(ERROR_PAYMENT_METHOD, {position: toast.POSITION.TOP_RIGHT});
            bag.setSubmitting(false);
          });
        }}
        render={(props) => (
          <form name="add_credit_card" className="payment-form" onSubmit={props.handleSubmit}>
            {!this.props.isEditing && <div className="row">
              <div className="col-md-12">
                <div className="form-group customSelect">
                  <BootstrapField component="select" name="type">
                    <option value={""}>Account Type</option>
                    <option value="C">Checking</option>
                    <option value={"S"}>Saving Account</option>
                    <option value={"X"}>Corporate Checking</option>
                  </BootstrapField>
                  <FontAwesomeIcon icon={faChevronDown} className={"select-arrow"}/>
                  <BootstrapError name="type"/>
                </div>
              </div>
            </div>}
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <BootstrapField type="text" name="routing_number" placeholder="Routing Number"
                                  disabled={this.props.isEditing}/>
                  <BootstrapError name="routing_number"/>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <BootstrapField type="text" name="account_number" placeholder="Account Number"
                                  disabled={this.props.isEditing}/>
                  <BootstrapError name="account_number"/>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <BootstrapField type="text" name="name" placeholder="Name on Account"/>
                  <BootstrapError name="name"/>
                </div>
              </div>
            </div>
            <div className={"row"}>
            {!this.props.alwaysSaveOnFile && !this.props.isEditing && <div className="col-md-6">
                <div className="form-check">
                  <input className="form-check-input rounded-circle" type="checkbox" checked={props.values.save_on_file}
                         id="save_on_file"
                         name={"save_on_file"} onChange={props.handleChange}/>
                  <label className="form-check-label save-on-file-label" htmlFor="save_on_file">
                    Save On File
                  </label>
                </div>
              </div>}
              <div className="col-md-6">
                  {props.values.save_on_file && <div className="form-check">
                      <input className="form-check-input rounded-circle" type="checkbox" checked={props.values.make_default}
                             id="make_default"
                             name={"make_default"} onChange={props.handleChange}/>
                      <label className="form-check-label save-on-file-label" htmlFor="make_default">
                          Set as default
                      </label>
                  </div>}
              </div>
            </div>
            <div className={"row"}>
              <div className="col-md-12 text-center">
                <button className={"btn btn-primary save-card-button"} type="submit"//onClick={this.saveCard}
                        disabled={props.isSubmitting}
                >{this.buttonText()}
                </button>
              </div>
            </div>
          </form>
        )}/>
    </div>;
  }
}

AddCheckForm.defaultProps = {
  alwaysSaveOnFile: false,
  save: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
};

AddCheckForm.propTypes = {
  payment: PropTypes.object.isRequired,
  save: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
};

export default connect((state, props) => {
    return {
      payerAccount: getPayerAccount(state, props),
      selectedPrimaryAccount: getSelectedPrimaryAccount(state, props),
      selectedSecondaryAccount: getSelectedSecondaryAccount(state, props),
    }
  }
)(AddCheckForm);
